var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import ActionButtons from './action_buttons';
import ButtonComponent from "../../comments/button";
import { useDispatch } from 'react-redux';
import { layerAction } from "../../reducers/layer";
import WrapComponent from "../../comments/wrap";
var ConfirmLayer = function (_a) {
    var message = _a.message, btnTxt = _a.btnTxt, action = _a.action;
    var dispatch = useDispatch();
    var onCloseHandler = function () {
        dispatch(layerAction({
            name: null,
            data: null
        }));
    };
    return (React.createElement(WrapComponent, null,
        React.createElement(ButtonComponent, { type: 'close', onClick: onCloseHandler }),
        React.createElement(Content, null,
            React.createElement("p", { className: "basic_txt center" },
                React.createElement("b", null, message)),
            React.createElement(ActionButtons, { actionButton: {
                    text: btnTxt,
                    action: function () {
                        action();
                        // 2022-08-05 로그인후 ref 경로 추가
                        //window.location.href = process.env.REACT_APP_SSO_URL as string
                        // window.location.href = process.env.REACT_APP_SSO_URL + '?returnUrl=' + encodeURIComponent(
                        //     window.location.hostname + window.location.pathname,
                        // )
                    }
                } }))));
};
var Content = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export default ConfirmLayer;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/layer/confirm_layer.tsx
// module id = 305
// module chunks = 0